module.exports = new __parcel__URL__("cactus.0c5c265c.svg").toString();